import type { CityConfig } from "../city-template/types";

export const columbiaConfig: CityConfig = {
  city: "Columbia",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "columbia",
  route: "/cities/columbia",
  title: "Emergency Passport Columbia, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Columbia, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for Columbia, Ellicott City, Laurel, and Jessup residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Columbia, MD",
  heroSubtitle: "Columbia travelers — from the planned community's villages to Howard County's corridors — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Howard County and western Baltimore County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20Columbia%20Maryland%20planned%20community%20with%20Lake%20Kittamaquundi%20in%20the%20foreground%2C%20modern%20residential%20and%20commercial%20buildings%2C%20lush%20green%20trees%20and%20walking%20paths%2C%20Columbia%20Town%20Center%20visible%20in%20the%20background%2C%20warm%20afternoon%20sunlight%2C%20professional%20suburban%20photography%2C%20no%20visible%20text%20or%20people%2C%20clean%20and%20vibrant%20community%20atmosphere&width=1800&height=700&seq=columbia-hero-001&orientation=landscape",
  heroImageAlt: "Aerial view of Columbia Maryland planned community with Lake Kittamaqundi and Columbia Town Center",
  geoPosition: "39.2037;-76.8610",
  geoPlacename: "Columbia, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 50–60 minutes from Columbia via I-95 S",
  },
  nearbyCitiesZips: [
    { name: "Columbia", zips: "21044, 21045, 21046" },
    { name: "Ellicott City", zips: "21041, 21042, 21043" },
    { name: "Laurel", zips: "20707, 20708, 20709, 20723, 20724, 20725, 20726" },
    { name: "Jessup", zips: "20701, 20794" },
    { name: "Clarksville", zips: "21029" },
    { name: "Fulton", zips: "20759" },
    { name: "Highland", zips: "20777" },
    { name: "Savage", zips: "20763" },
    { name: "Odenton", zips: "21113" },
    { name: "Gambrills", zips: "21054" },
    { name: "Hanover", zips: "21076" },
    { name: "Bowie", zips: "20715, 20716, 20717, 20718, 20719, 20720, 20721" },
    { name: "Baltimore", zips: "21201, 21202, 21205, 21206, 21207, 21209, 21210, 21211, 21212, 21213, 21214, 21215, 21216, 21217, 21218, 21222, 21223, 21224, 21225, 21226, 21227, 21228, 21229, 21230, 21231, 21233, 21234, 21236, 21237, 21239, 21244, 21250, 21251, 21252" },
    { name: "Towson", zips: "21204, 21252, 21286" },
    { name: "Catonsville", zips: "21228, 21229" },
    { name: "Glen Burnie", zips: "21060, 21061, 21062" },
    { name: "Silver Spring", zips: "20901, 20902, 20903, 20904, 20905, 20906, 20910, 20911" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Columbia and Howard County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-community-line", title: "Planned Community Focus", desc: "Serving all Columbia villages and surrounding Howard County" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Baltimore, MD", route: "/cities/baltimore" },
    { name: "Emergency passport help in Ellicott City, MD", route: "/cities/ellicott-city" },
    { name: "Urgent passport services in Bethesda, MD", route: "/cities/bethesda" },
    { name: "Maryland passport services overview", route: "/states/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Columbia, Maryland remotely via secure registered courier. We do not have a walk-in office in Columbia — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Howard County travelers without the long drive to downtown DC.",
  fpcOfficeAddress: "401 E Pratt St, Baltimore, Maryland 21202",
  fpcOfficeDistance: "Serving Columbia, Ellicott City, Laurel, Jessup, and greater Howard County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Columbia and Howard County. From the villages of Wilde Lake, Harper's Choice, and Oakland Mills to the bustling corridors of Route 175 and Route 32, from the historic streets of Ellicott City to the suburban neighborhoods of Laurel and Jessup — we serve all of Howard County's diverse communities.",
  nearbyCitiesIntro: "We serve Columbia and nearby communities including Ellicott City, Laurel, Jessup, Clarksville, Fulton, Highland, Savage, Odenton, Gambrills, and Hanover. We also serve western Baltimore County and Anne Arundel County residents who prefer our expedited service.",
  howItWorksIntro: "Most Columbia travelers complete everything online and ship documents overnight. No need to drive 50–60 minutes to downtown DC or navigate the Baltimore-Washington Parkway during rush hour.",
  mistakesIntro: "Columbia is a major suburban commuter hub with families who travel internationally. Here are the most common passport mistakes we see from Columbia travelers.",
  testimonialsIntro: "Columbia travelers — from families to government contractors to university staff — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Columbia, MD? Here are the most common ones we hear from Howard County travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Maryland Department of Health Vital Statistics Administration. Online, mail, or in-person at the Baltimore vital records office.", url: "https://health.maryland.gov/vsa/Pages/home.aspx" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through the Maryland Department of Health Vital Statistics. Required for estate, legal, and survivor benefit matters.", url: "https://health.maryland.gov/vsa/Pages/home.aspx" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request certified marriage records from the Howard County Circuit Court Clerk. Required for name change passport applications.", url: "https://www.howardcountymd.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Howard County Circuit Court. Required for name change passport corrections.", url: "https://www.howardcountymd.gov/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for family vacation and business travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 50–60 min to downtown DC", "Full day commitment — challenging for working families"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Columbia travelers with immediate departure needs — as fast as 24 hours. Perfect for family vacations, business trips, and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Family and business travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Columbia adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Columbia address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Columbia residents and families — including university students and new professionals.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Columbia residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Columbia families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Columbia residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Columbia MD", description: "Urgent passport processing for Columbia Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Columbia MD", description: "Fast passport renewal for Columbia Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Columbia MD", description: "New passport application services for Columbia Maryland residents applying for their first passport." },
    { name: "Child Passport Columbia MD", description: "Minor passport services for Columbia Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "Michelle H.",
      location: "Wilde Lake, Columbia",
      rating: 5,
      text: "Disney cruise for the whole family in 8 days. Four passports processed in under a week. The agent coordinated everything — we just shipped the documents from the UPS Store on Little Patuxent Parkway.",
      service: "Family Passport Bundle",
    },
    {
      name: "Thomas R.",
      location: "Ellicott City, MD",
      rating: 5,
      text: "Business trip to Singapore with 10 days notice. Fast Passport Center had my emergency passport ready in 3 days. No need to drive to DC — everything shipped overnight.",
      service: "Emergency Passport",
    },
    {
      name: "Amanda B.",
      location: "Laurel, MD",
      rating: 5,
      text: "Lost my passport the week before our honeymoon in Greece. I was devastated. They walked me through the replacement process and had it in my hands in 48 hours. Truly saved our trip.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Kevin D.",
      location: "Columbia, MD",
      rating: 5,
      text: "Last-minute study abroad requirement for my daughter. Fast Passport Center handled her first-time passport in under 2 weeks. Great communication throughout the process.",
      service: "First-Time Passport",
    },
  ],
  facilities: [
    {
      id: "columbia-1",
      name: "Columbia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8805 Centre Park Dr",
      city: "Columbia",
      state: "MD",
      zip: "21045",
      phone: "(410) 730-2220",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Columbia Town Center, near the Mall in Columbia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Columbia acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient parking at the Town Center.",
      icon: "ri-mail-line",
    },
    {
      id: "columbia-2",
      name: "Ellicott City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4450 Montgomery Rd",
      city: "Ellicott City",
      state: "MD",
      zip: "21043",
      phone: "(410) 465-7734",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Ellicott City, approximately 5 miles west of Columbia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Ellicott City and western Howard County residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "columbia-3",
      name: "Laurel Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "443 Main St",
      city: "Laurel",
      state: "MD",
      zip: "20707",
      phone: "(301) 776-4593",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Laurel, approximately 8 miles south of Columbia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Laurel, Jessup, and southern Howard County residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "columbia-4",
      name: "Glen Burnie Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "60 W Ordnance Rd",
      city: "Glen Burnie",
      state: "MD",
      zip: "21060",
      phone: "(410) 766-6224",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Glen Burnie, approximately 15 miles east of Columbia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Anne Arundel County and eastern Howard County residents. Good alternative when Columbia appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "columbia-5",
      name: "Howard County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "8360 Court Ave",
      city: "Ellicott City",
      state: "MD",
      zip: "21043",
      phone: "(410) 313-3828",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Ellicott City, approximately 5 miles west of Columbia",
      website: "https://www.howardcountymd.gov/",
      websiteLabel: "Howard County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office locations. Accessible via Route 40.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 50–60 min drive to downtown DC", fpc: "No — ship from Columbia" },
    { feature: "Family Travel Support", agency: "No flexibility for family needs", fpc: "Yes — we handle multi-passport family cases" },
    { feature: "Howard County Village Network", agency: "No multi-village coordination", fpc: "Yes — serve all 10 Columbia villages" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Family Cruise Planning", agency: "No cruise timeline expertise", fpc: "Yes — cruise and vacation family coordination" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Columbia's busy families and commuters often discover passport needs just weeks before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Columbia sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Columbia and Howard County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Columbia Post Office appointments fill up fast, especially during summer and holiday travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "Columbia residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Columbia, Ellicott City, or Laurel." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near Columbia Town Center or along Route 32." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Columbia address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Columbia, MD?", a: "Fast Passport Center offers emergency passport processing in Columbia, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency (50–60 minutes from Columbia) — without you needing to make the drive or fight I-95 traffic." },
    { q: "Does Columbia have its own passport agency?", a: "No — neither Columbia nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 50–60 minutes from Columbia via I-95 S. Fast Passport Center's courier service means Columbia residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live in Ellicott City or Laurel?", a: "Absolutely. Fast Passport Center serves all of the Columbia area including Ellicott City, Laurel, Jessup, Clarksville, Fulton, Highland, and Savage. We also serve Anne Arundel County and western Baltimore County residents. Our service works the same way — complete your application online, ship your documents, and we handle the rest." },
    { q: "How much does an expedited passport cost in Columbia, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Columbia travelers use for international flights?", a: "Most Columbia residents fly internationally through Baltimore-Washington International Airport (BWI), approximately 20–25 minutes east via MD-32. Washington Dulles (IAD) is 45–55 minutes west. Reagan National (DCA) is 40–50 minutes south. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Columbia?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Columbia, Ellicott City, Laurel, and surrounding areas. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to Columbia?", a: "The Columbia Post Office at 8805 Centre Park Dr is the primary Columbia acceptance facility. The Ellicott City Post Office at 4450 Montgomery Rd serves western Howard County. The Laurel Post Office at 443 Main St serves southern Howard County. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Columbia residents should plan ahead, especially for family vacations and summer cruises." },
  ],
  photoLocations: [
    { name: "Walgreens — Columbia", address: "6151 Dobbin Center Way, Columbia, MD 21045", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Columbia", address: "10300 Little Patuxent Pkwy, Columbia, MD 21044", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "UPS Store — Ellicott City", address: "9250 Baltimore National Pike, Ellicott City, MD 21042", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Laurel", address: "14700 Baltimore Ave, Laurel, MD 20707", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/" },
  ],
  dmvLocations: [
    { name: "MVA — Glen Burnie", address: "6601 Ritchie Hwy, Glen Burnie, MD 21062", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Flagship MVA location serving Howard and Anne Arundel Counties. REAL ID processing available.", featured: true },
    { name: "MVA — Columbia", address: "6490 Dobbin Rd, Columbia, MD 21045", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Howard County and western Baltimore County. Full service including REAL ID.", featured: false },
  ],
  airports: [
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "20–25 minutes from Columbia via MD-32 E",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Primary international departure airport for Columbia travelers. Direct flights to London, Cancun, Reykjavik, and the Caribbean. Southwest Airlines hub with extensive domestic connections.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: true,
    },
    {
      code: "DCA",
      name: "Reagan National (Washington DC)",
      distance: "40–50 minutes from Columbia via MD-32 S",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Secondary option for domestic connections to international hubs. Major business travel airport.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Flight Info",
      featured: false,
    },
    {
      code: "IAD",
      name: "Dulles International (Washington DC)",
      distance: "45–55 minutes from Columbia via MD-32 W",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Alternative for long-haul international flights to Europe and Asia. United Airlines hub.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: false,
    },
  ],
};